import {
  DownArrowOutlined,
  BentArrowBottomLeftOutlined,
  UpArrowOutlined,
} from "@toddle-edu/ds-icons";
import React from "react";
import { useI18n } from "Hooks";
import classNames from "classnames";
import classes from "./Footer.scss";
import { Trans } from "react-i18next";
import { HEX_CODES_FOR_SPECIAL_SYMBOLS } from "Platform/components/GlobalHeader/modules/Utils";
import { getIsGlobalSearchJumpToV2Enabled } from "../Utils";
import { isWindows } from "Utils/DeviceDetectHelpers";
import { useKeyboardShortcutsContext } from "@toddle-edu/ds-web";

const KeyNameComp = props => {
  const { label } = props;
  return (
    <span
      className={classes.keyNameContainer}
      dangerouslySetInnerHTML={{ __html: label }}
    />
  );
};

const KeyIconComp = props => {
  const { icon: Icon } = props;
  return (
    <span className={classes.keyIconContainer}>
      <Icon size="xxx-small" variant="subtle" />
    </span>
  );
};

const Footer = () => {
  const { t } = useI18n(["common", "integration"]);
  const isGlobalSearchJumpToV2Enabled = getIsGlobalSearchJumpToV2Enabled();

  const { areShortcutsEnabled } = useKeyboardShortcutsContext();

  return (
    <div
      className={classNames("text-body-3 text-textSubtle", classes.container)}
    >
      <div className={classes.leftContainer}>
        {!isGlobalSearchJumpToV2Enabled ? (
          areShortcutsEnabled ? (
            <Trans
              i18nKey={
                "integration:global_search_header_text_with_single_key_press"
              }
            >
              Press <KeyNameComp label="J" /> anywhere on Toddle to start a
              quick search.
            </Trans>
          ) : null
        ) : (
          <>
            {areShortcutsEnabled ? (
              <>
                <div className={classes.localeContainer}>
                  <Trans i18nKey={"integration:open_quick_search"}>
                    <KeyNameComp
                      label={
                        isWindows() ? "Ctrl" : HEX_CODES_FOR_SPECIAL_SYMBOLS.CMD
                      }
                    />
                    <KeyNameComp label="/" /> to open the quick search
                  </Trans>
                </div>
                <div className={classes.separator} />
              </>
            ) : null}

            <div className={classes.localeContainer}>
              <Trans i18nKey={"integration:close_quick_search"}>
                <KeyNameComp label="Esc" /> to close
              </Trans>
            </div>
          </>
        )}
      </div>
      <div className={classes.rightContainer}>
        <div className={classes.inlineFlex}>
          <div className={classes.navigatorIcon}>
            <KeyIconComp icon={UpArrowOutlined} />
            <KeyIconComp icon={DownArrowOutlined} />
          </div>
          <div className={"text-body-3 text-textSubtle"}>
            {t("common:to_navigate")}
          </div>
        </div>
        <div className={classes.inlineFlex}>
          <KeyIconComp icon={BentArrowBottomLeftOutlined} />
          <div className={"text-body-3 text-textSubtle"}>
            {t("common:to_select")}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Footer;
